import { acceptTerms } from './acceptTerms'
import { bulkUpdateStatus } from './bulkUpdateStatus'
import { changeArea } from './changeArea'
import { changeDepartament } from './changeDepartament'
import { changePassword } from './changePassword'
import { createInvitationLink } from './createInvitationLink'
import { createUser } from './createUser'
import { deleteUser } from './deleteUser'
import { getDownloadReport } from './downloadReport'
import { downloadUsersHistory } from './downloadUsersHistory'
import { getDashboardActiveUsersRate } from './getDashboardActiveUsersRate'
import { getDashboardTopTenUsers } from './getDashboardTopTenActiveUsers'
import { getInformation } from './getInformation'
import { getInvitationLink } from './getInvitationLink'
import { getMyEvaluations } from './getMyEvaluations'
import { getPublicInvitationLink } from './getPublicInvitationLink'
import { getUsers } from './getUsers'
import { getUsersForFilters } from './getUsersForFilters'
import { importCsv } from './importCsv'
import { listFiltersRanking } from './listFiltersRanking'
import { listUsersByAreas } from './listUsersByAreas'
import { listUsersByDepartment } from './listUsersByDepartment'
import { getMe } from './me'
import { getRankingSimple } from './rankingSimple'
import { registerAutonomou } from './registerAutonomou'
import { resetPassword } from './resetPassword'
import { searchUsersForMention } from './searchUsersForMention'
import { sendResetPasswordToken } from './sendResetPasswordToken'
import { syncMicrosoftUsers } from './syncMicrosoftUsers'
import { toggleStatus } from './toggleStatus'
import { update } from './update'
import { updateAvatar } from './updateAvatar'
import { updateCurrentUser } from './updateCurrentUser'
import { updateUser } from './updateUser'

export const usersService = {
  getDownloadReport,
  changePassword,
  getMe,
  resetPassword,
  sendResetPasswordToken,
  updateUser,
  getInformation,
  getRankingSimple,
  getUsers,
  syncMicrosoftUsers,
  importCsv,
  createInvitationLink,
  deleteUser,
  toggleStatus,
  bulkUpdateStatus,
  createUser,
  update,
  changeArea,
  changeDepartament,
  getMyEvaluations,
  updateAvatar,
  downloadUsersHistory,
  getDashboardActiveUsersRate,
  getDashboardTopTenUsers,
  acceptTerms,
  getInvitationLink,
  getPublicInvitationLink,
  registerAutonomou,
  getUsersForFilters,
  updateCurrentUser,
  searchUsersForMention,
  listFiltersRanking,
  listUsersByAreas,
  listUsersByDepartment,
}
